import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=e1e3b716&"
import script from "./NewRegister.vue?vue&type=script&lang=js&"
export * from "./NewRegister.vue?vue&type=script&lang=js&"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=e1e3b716&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports